import React,{ useState, useEffect }  from 'react';
import { BrowserRouter as Router, Switch, Route, NavLink} from 'react-router-dom';
import {  
          AppBar, 
          Avatar,  
          Button,
          Chip,
          Collapse,
          CssBaseline, 
          Dialog,
          DialogActions,
          DialogContent,
          DialogTitle as MuiDialogTitle,
          Divider, 
          Drawer, 
          FormControl,
          Grid,
          IconButton, 
          List,
          ListItem,
          ListItemIcon,
          ListItemText,
          Menu,
          MenuItem,
          Select,
          Snackbar,
          Slide,
          Toolbar,
          Typography,
          MuiThemeProvider,
          withWidth,
}  from '@material-ui/core';
import clsx from 'clsx';
import { Alert } from '@material-ui/lab';
import { 
          AccountBalance as AccountBalanceIcon,
          AddCircle as AddCircleIcon,
          Add as AddIcon,
          AddShoppingCart as AddShoppingCartIcon,
          Apartment as ApartmentIcon,
          ArrowRight as RightIcon,
          Assessment as AssessmentIcon,
          AssignmentTurnedIn as AssignmentTurnedInIcon,
          AttachMoney as AttachMoneyIcon,
          Ballot as BallotIcon,
          Build as BuildIcon,
          Cached as CachedIcon,
          ChevronLeft as ChevronLeftIcon,
          Close as CloseIcon,
          Delete as DeleteIcon,
          DoneOutline as DoneOutlineIcon,
          EventAvailable as EventAvailableIcon,
          ExpandLess,
          ExpandMore,
          Explore as ExploreIcon,
          GroupAdd as GroupAddIcon,
          Home as HomeIcon,
          HomeWork as HomeWorkIcon,
          List as ListIcon,
          ListAlt as ListAltIcon,
          LocalAtm as LocalAtmIcon,
          Menu as MenuIcon, 
          MoneyOff as MoneyOffIcon,
          NotListedLocation as NotListedLocationIcon,
          Person as PersonIcon,
          PersonPin as PersonPinIcon,
          PhonelinkSetup as PhonelinkSetupIcon,
          PinDrop as PinDropIcon,
          People as PeopleIcon,
          QueuePlayNext as QueuePlayNextIcon,
          Router as RouterIcon,
          Save as SaveIcon,
          Sms as SmsIcon,
          Settings as SettingsIcon,
          Speed as SpeedIcon,
          SupervisedUserCircle as SupervisedUserCircleIcon,
          SwapVerticalCircle as SwapVerticalCircleIcon,
          TouchApp as TouchAppIcon,
          WhatsApp as WhatsAppIcon,
          Work as WorkIcon,
          WorkOutline as WorkOutlineIcon,
        } from '@material-ui/icons';
import { createTheme, makeStyles, withStyles } from '@material-ui/core/styles';
import { red, green, deepOrange, grey, indigo, blue } from '@material-ui/core/colors';
import Alm_Matriz from './Almacen/Matriz';
import Alm_Proveedores from './Almacen/Proveedores';
import Alm_Equipos from './Almacen/Equipos';
import Alm_Stock from './Almacen/Stock';
import Alm_Tipos from './Almacen/Tipos';
import Alm_Marcas from './Almacen/Marcas';
import Alm_Tecnologia from './Almacen/Tecnologia';
import Mikrotik_List from './Mikrotik_List/Mikrotik_List';
import Servicios_Pagos from './Servicios/Pagos';
import Younet_ClientAdd from './Clientes/Add';
import Younet_ClientList from './Clientes/Listado';
import Younet_ClientShow from './Clientes/AddSmall';
import Younet_ClientListDet from './Clientes/ListadoDetallado';
import Younet_ChangeZone from './Clientes/ChangeZone';
import Clientes_CambioPlanes from './Clientes/CambioPlanes';
import { MigracionMk } from './Clientes/MigracionMk/MigracionMk';
import Younet_ChangeWifi from './Clientes/ChangeWifi';
import Servicios_Promesas from './Servicios/Promesas';
import Adicionales_Crear from './Adicionales/Crear';
import Adicionales_Listado from './Adicionales/Listado'
import Servicios_Instalaciones from './Servicios/Instalaciones';
import Servicios_Bancos from './Servicios/Bancos';
import Younet_ReporteriaPagos from './Reportes/Younet_ReporteriaPagos';
import Inicio from './Inicio';
import Login from './Login'; 
import OT_Crear from './OT/Crear';
import Descuentos_Crear from './Descuentos/Crear';
import Descuentos_Listado from './Descuentos/Listado';
import OT_Listado from './OT/Listado';
import Conf_Backups from './Configuracion/Backups';
import Conf_CambioIP from './Configuracion/CambioIP';
import Conf_Empresas from './Configuracion/Empresas/Empresas';
import Conf_Equipos from './Equipos/Equipos';
import Conf_Feriados from './Configuracion/Feriados';
import Conf_Modulos from './Configuracion/Modulos';
import Conf_Notificaciones from './Configuracion/Notificaciones';
import Conf_Planes from './Configuracion/Planes';
import Conf_Procesos from './Configuracion/Procesos';
import Conf_Tareas from './Configuracion/Tareas';
import Conf_Tecnicos from './Configuracion/Tecnicos';
import Conf_Usuarios from './Configuracion/Usuarios';
import Conf_Whatsapps from './Configuracion/Whatsapps';
import Conf_Wweb from './Configuracion/Wweb';
import Conf_Zonas from './Zonas/Zonas';
import PrivateRoute from './PrivateRoute';
import { AuthContext } from "./Auth";
import LogoPng from './images/logofontwhite.png';
import { Scrollbars } from 'react-custom-scrollbars-2';
import useSection from './HooksPerson/useSection';
import ReportesRecibos from './Reportes/Recibos';
import ReportesFacturas from './Reportes/Facturas';
import ReportesArcotel from './Reportes/Arcotel';
import { 
  CalculatorOutlined as CalculatorOutlinedIcon,
  DeploymentUnitOutlined  as DeploymentUnitOutlinedIcon,
  FileAddOutlined as FileAddOutlinedIcon,
  FileSearchOutlined as FileSearchOutlinedIcon,
  MediumOutlined as MediumOutlinedIcon,
  NotificationOutlined as NotificationOutlinedIcon,
  RocketOutlined as RocketOutlinedIcon,
} from '@ant-design/icons';
import ImageUploading from 'react-images-uploading';
import { message as messageAntd } from 'antd';
import FacebookCircularProgress from './Elementos/FacebookCircularProgress';
import ImgsViewer from "react-images-viewer";

const drawerWidth = 240;

const styles2 = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: red[900],
  },
});

const DialogTitle = withStyles(styles2)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems:'flex-start',
    paddingTop:10,
    height: '99vh',
  },
  root2: {
    display: 'flex',
    //background:`url('/images/FONDO.jpg')`,
    //backgroundSize: 'container',
    //backgroundRepeat: 'no-repeat',
    //backgroundSize: '100.5% 100%',
    justifyContent:'center',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    padding:0,
  },
  appBar: {
    color:'#ff9e00',
    height:60
  },
  appBarRep: {
    color:'#fff',
    backgroundColor:'#000'
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color:grey[100]
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: 240,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap:10,
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding:0,
    marginTop:50,
    maxHeight:'90vh',
    width:'100vw',
    overflow: 'hidden',
  },
  contentLogin: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop:0,
    padding:0,
    width:'100vw',
    overflow: 'hidden',
    maxHeight:'100vh',
    height:'100vh'
  },
  nested: {
    backgroundColor:'#fff',
    height:43,
    margin:5,
    padding:'0px 0px 0px 15px',
  },
  listit: {
    textOverflow: 'ellipsis',
    overflow:'hidden',
    whiteSpace:'nowrap',
    position:'relative',
    top:-2
  },
  listot:{
    color: indigo[900]
  },
  divAv:{
    //backgroundImage: `url('/images/pestanaverde.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 75,
    color:'#fff',
    textDecoration:'none',
    '&:hover':{
      textDecoration:'none',
    }
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
    color:'#fff',
    border:'1px solid #fff',
    borderRadius:10,
    padding:'0px 5px',
    textDecoration:'none',
    '&:hover':{
      textDecoration:'none',
    }
  },
  navlink:{
    alignItems:'center',
    backgroundColor:'#fff',
    color:'#1a237e',
    display:'flex',
    height:40,
    justifyContent:'space-between',
    padding:4,
    textDecoration: 'none', 
    width:'100%', 
    "&:hover": {
      color:'#1a237e',
    },
  },
  containerOption:{
    padding:0,
    margin:0
  },
  optionActive:{
    backgroundColor:'#1a237e',
    color:'#fff',
    padding:4,
    "&:hover": {
      color:'#fff',
    },
  },
  iconRight:{
    color:'#fff'
  }
}));

const Traktecom = createTheme({
  palette: {
    primary: {
      main: indigo[900], //#1a237e
    },
    secondary: {
      main: deepOrange.A400, //#ff3d00
    },
  },
});

const NoAcceso = ()=>(<div><h1 style={{color:'red'}}>No Tiene Acceso</h1></div>);

function App({width:widthWin}) {
    //const location = useLocation();
    const classes = useStyles();
    const fecha = new Date();
    const existingTokens = JSON.parse(localStorage.getItem("tokens_byYounet_"));
    const [ anchorEl, setAnchorEl] = useState(null);
    const   openUser = Boolean(anchorEl);
    const [ open, setOpen ] = useState(false);
    const [ showAppbar, setShowAppbar] =  useState(false);
    const [ isAdmin, setAdmin ] = useState(false);
    const [ snacks, setSnacks] = useState({status:false, message:'', severity:'success'});
    const [ authTokens, setAuthTokens] = useState(existingTokens);
    const [ isLoggedIn, setLoggedIn] = useState(false);
    const [ isInLogin, setIsInLogin ] = useState(false);
    const [ openMikrotik, handleClickMikrotik ] = useSection();
    const [ Clientes, handleClickClientes ] = useSection();
    const [ Servicios, handleClickServicios ] = useSection();
    const [ Reporteria, handleClickReporteria ] = useSection();
    const [ Adicionales, handleClickAdicionales ] = useSection();
    const [ Descuentos, handleClickDescuentos ] = useSection();
    const [ Otrabajo, handleClickOtrabajo ] = useSection();
    const [ openAlmacen, handleClickAlmacen ] = useSection();
    const [ listConf, handleClickConf ] = useSection();
    const [ ageWork, setAgeWork ] = useState(parseInt(fecha.getFullYear()));
    const [ getSecciones, setSecciones ] = useState({});
    const [ getAccesos, setAccesos ] = useState({});
    const [ imagesAvatar, setImagesAvatar ] = useState([]);
    const [ isOpenAvatar, setOpenAvatar ] = useState(false);
    const [ isImgA, setImgA ] = useState(false);
    const [ openPhotoA, setOpenPhotoA ] = useState(false);
    const [ isChangeA, setChangeA ] = useState(false);
    const [ getAvatar, setAvatar ] = useState('');
    const [ isSavingAvatar, setSavingAvatar ] = useState(false);
    const [ updateAvatar, setUpdateAvatar ] = useState(false);
    const [ getRuta, setRuta ] = useState('');
    const [ viewerIsOpen, setOpenViewer ] = useState(false);


    useEffect(()=>{      
      if(localStorage.getItem("tokens_byYounet_")){
        const objeto = {};
        for(const el in existingTokens.Accesos){
          const elemento = existingTokens.Accesos[el]
          objeto[elemento.Modulo] = elemento.isActive;
        }
        const arrSec = [];
        for(const el in existingTokens.Accesos){
          const elemento = existingTokens.Accesos[el]
          if(elemento.isActive) arrSec.push(elemento.Seccion)
        }
        const Secciones = new Set(arrSec);
        const Secciones_ = [...Secciones];
        const objetoSec = {}
        for(const el in Secciones_ ){
          const elemento = Secciones_[el];
          objetoSec[elemento] = true;
        }
        setShowAppbar(true);
        setOpen(true);
        setLoggedIn(true);
        existingTokens.Type === 'ADMINISTRADOR' && setAdmin(true);
        setAccesos(objeto);
        setSecciones(objetoSec);
        if(existingTokens.Avatar){
          if(existingTokens.Avatar !== ''){
            setImgA(true);
            setAvatar(existingTokens.Avatar);
            setImagesAvatar([{data_url:existingTokens.Avatar}]);
          }
        }
       }
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
      if(updateAvatar){
        setSavingAvatar(false);
        setUpdateAvatar(false);
      }
    },[updateAvatar])

    const setTokens = (data) => {
      localStorage.setItem("tokens_byYounet_", JSON.stringify(data));
      setAuthTokens(data);
      const objeto = {};
        for(const el in data.Accesos){
          const elemento = data.Accesos[el]
          objeto[elemento.Modulo] = elemento.isActive;
        }
      const arrSec = [];
      for(const el in data.Accesos){
        const elemento = data.Accesos[el]
        if(elemento.isActive) arrSec.push(elemento.Seccion)
      }
      const Secciones = new Set(arrSec);
      const Secciones_ = [...Secciones];
      const objetoSec = {}
      for(const el in Secciones_ ){
        const elemento = Secciones_[el];
        objetoSec[elemento] = true;
      }
      setAccesos(objeto);
      setSecciones(objetoSec);
    };

    const handleDrawerOpen = () => {setOpen(true);};

    const handleDrawerClose = () => {setOpen(false);};

    const HandleChangeAge = (e)=>{setAgeWork(e.target.value);}

    const drawer = (
      <div>
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose} style={{color:indigo[900], height:50}}>
            <ChevronLeftIcon />
          </IconButton>
          <IconButton style={{height:50}} onClick={()=>{setRuta('/Home');}}>
            <NavLink to="/" className="link" ><HomeIcon style={{color:green[500], position:'relative', top:4}}/></NavLink>
          </IconButton>
        </div>
        <Divider />
        {   
          getSecciones.Mikrotik ?
            <React.Fragment>
              <List>
                  <ListItem button onClick={ handleClickMikrotik }>
                    <ListItemIcon className={classes.listot}><RouterIcon /></ListItemIcon>
                    <ListItemText className={classes.listot} primary='MIKROTIK' />
                    {openMikrotik ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={openMikrotik} timeout="auto" unmountOnExit>  
                    <List component="div" disablePadding>                                
                      { getAccesos.Mikrotik_List ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Mikrotik/List'); }} >
                          <NavLink to ="/Mikrotik_List" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <ListIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="LIST" />                           
                                </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }   
                    </List>                
                  </Collapse>
              </List> 
              <Divider />
            </React.Fragment>
          : null
        }
        {   
          getSecciones.Clientes ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickClientes } >
                  <ListItemIcon className={classes.listot}><PeopleIcon  /></ListItemIcon>
                  <ListItemText className={classes.listot} primary='CLIENTES' />
                  {Clientes ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                  <Collapse in={Clientes} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      { getAccesos.Younet_ClientAdd ? 
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/Add'); }} >
                          <NavLink to ="/Clientes_Add" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <AddCircleIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="ADD" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Younet_ChangeZone ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/CambioZona'); }} >
                          <NavLink to ="/Clientes_CambiarZona" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SwapVerticalCircleIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="CAMBIAR ZONA" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      } 
                      { getAccesos.Clientes_CambioPlanes ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/CambioPlanes'); }} >
                          <NavLink to ="/Clientes_CambioPlanes" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SpeedIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="CAMBIAR PLANES" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      } 
                      { getAccesos.Younet_ClientList ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/Listado'); }} >
                          <NavLink to ="/Clientes_Listado" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <ListIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="LIST" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Younet_ClientListDet ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/ListadoD'); }} >
                          <NavLink to ="/Clientes_ListadoD" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <ListIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="LIST DETLLD" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Younet_ClientShow ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/Soporte'); }} >
                          <NavLink to ="/Clientes_Soporte" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <PersonPinIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="SOPORTE" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                         { getAccesos.MigracionMk ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Clientes/MigracionMk'); }} >
                          <NavLink to ="/Clientes/MigracionMk" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <TouchAppIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="MIGRACION_MK" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }   
                    </List>      
                  </Collapse>
              </List> 
              <Divider/>
            </React.Fragment>
          : null
        }    
        {  
          getSecciones.Adicionales ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickAdicionales }>
                  <ListItemIcon className={classes.listot}>
                    <CalculatorOutlinedIcon style={{fontSize:24}}/>
                  </ListItemIcon>
                  <ListItemText className={classes.listot} primary='ADICIONALES' />
                  { Adicionales ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={Adicionales} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    { getAccesos.Adicionales_Crear ? 
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Adicionales/Crear'); }} >
                        <NavLink to ="/Adicionales_Crear" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <FileAddOutlinedIcon style={{fontSize:22}} />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="CREAR" />
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null 
                    }
                    { getAccesos.Adicionales_Listado ? 
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Adicionales/Listado'); }} >
                        <NavLink to ="/Adicionales_Listado" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <FileSearchOutlinedIcon style={{fontSize:22}} />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="LISTADO" />    
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                  </List>
                </Collapse>
              </List>
              <Divider/>
            </React.Fragment>
          : null
        }
        {  
          getSecciones.Descuentos ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickDescuentos }>
                  <ListItemIcon className={classes.listot}>
                    <MoneyOffIcon style={{fontSize:24}}/>
                  </ListItemIcon>
                  <ListItemText className={classes.listot} primary='DESCUENTOS' />
                  { Descuentos ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={Descuentos} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                  { getAccesos.Descuentos_Crear ?  
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Descuentos/Crear'); }} >
                      <NavLink to ="/Descuentos_Crear" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <FileAddOutlinedIcon style={{fontSize:22}} />
                          </Grid>
                          <Grid item xs={8}>
                            <ListItemText className={classes.listit} primary="CREAR" />
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  { getAccesos.Descuentos_Listado ?
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Descuentos/Listado'); }} >
                      <NavLink to ="/Descuentos_Listado" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <FileSearchOutlinedIcon style={{fontSize:22}} />
                          </Grid>
                          <Grid item xs={8}>
                            <ListItemText className={classes.listit} primary="LISTADO" />    
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  </List>
                </Collapse>
              </List>
              <Divider/>
            </React.Fragment> 
          : null
        }
        {
          getSecciones.Servicios ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickServicios }>
                  <ListItemIcon className={classes.listot}><DoneOutlineIcon /></ListItemIcon>
                  <ListItemText className={classes.listot} primary='SERVICIOS' />
                  {Servicios ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={Servicios} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  { getAccesos.Servicios_Bancos ?
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Servicios/Bancos'); }} >
                      <NavLink to ="/Servicios_Bancos" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <AccountBalanceIcon />
                          </Grid>
                          <Grid item xs={8}>               
                            <ListItemText className={classes.listit} primary="BANCOS" />
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  { getAccesos.Servicios_Instalaciones ?
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Servicios/Instalaciones'); }} >
                      <NavLink to ="/Servicios_Instalaciones" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <FileSearchOutlinedIcon style={{fontSize:24}}/>
                          </Grid>
                          <Grid item xs={8}>                 
                            <ListItemText className={classes.listit} primary="INSTALACION" />
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  { getAccesos.Servicios_Pagos ?
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Servicios/Pagos'); }} >
                      <NavLink to ="/Servicios_Pagos" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <LocalAtmIcon />
                          </Grid>
                          <Grid item xs={8}>               
                            <ListItemText className={classes.listit} primary="PAGOS" />
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  { getAccesos.Servicios_Promesas ?
                    <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Servicios/Promesas'); }} >
                      <NavLink to ="/Servicios_Promesas" activeClassName={classes.optionActive} className={classes.navlink}>
                        <Grid
                          alignItems='center' 
                          className={classes.containerOption}
                          container
                          justifyContent='space-between'
                        >
                          <Grid item >
                            <EventAvailableIcon />
                          </Grid>
                          <Grid item xs={8}>
                            <ListItemText className={classes.listit} primary="PROMESAS" />       
                          </Grid>
                          <Grid item>
                            <RightIcon className={classes.iconRight}/>  
                          </Grid>
                        </Grid>          
                      </NavLink>
                    </ListItem>  : null
                  }
                  </List>
                </Collapse>
              </List>
              <Divider/>
            </React.Fragment>
          : null
        }
        {
          getSecciones.Reporteria ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickReporteria }>
                  <ListItemIcon className={classes.listot}><AssessmentIcon /></ListItemIcon>
                  <ListItemText className={classes.listot} primary='REPORTERIA' />
                  {Reporteria ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={Reporteria} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    { getAccesos.ReportesArcotel ?
                      <ListItem button className={classes.nested} >
                        <NavLink to ="/Reporteria_Arcotel" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <WorkIcon />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="ARCOTEL" onClick={()=>{ setRuta('/Reporteria/Arcotel'); }} />              
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                    { getAccesos.Younet_ReporteriaPagos ?
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Reporteria/Pagos'); }} >
                        <NavLink to ="/Reporteria_Pagos" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <AttachMoneyIcon />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listitcc} primary="PAGOS" />              
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                    { getAccesos.ReportesRecibos ?
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Reporteria/Recibos'); }} >
                        <NavLink to ="/Reporteria_Recibos" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                                <ListAltIcon />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="RECIBOS" />              
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                    { getAccesos.ReportesFacturas ?
                      <ListItem button className={classes.nested} >
                        <NavLink to ="/Reporteria_Facturas" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <BallotIcon />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="FACTURAS" onClick={()=>{ setRuta('/Reporteria/Facturas'); }} />              
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                  </List>
                </Collapse>
              </List>
              <Divider/>
            </React.Fragment>
          : null
        }
        {
          getSecciones.Almacen ?
            <React.Fragment>
              <List> 
                  <ListItem button onClick={handleClickAlmacen}>
                    <ListItemIcon className={classes.listot}><HomeWorkIcon /></ListItemIcon>
                    <ListItemText className={classes.listot} primary='ALMACEN' />
                    {openAlmacen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={openAlmacen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                      { getAccesos.Alm_Matriz ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Matriz'); }} >
                          <NavLink to="/Almacen_Matriz" activeClassName={classes.optionActive} className={classes.navlink} >
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <PinDropIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="MATRIZ" />         
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Alm_Proveedores ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Proveedores'); }} >
                          <NavLink to ="/Almacen_Proveedores" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <GroupAddIcon/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="PROVEEDORES" />
                                </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid> 
                          </NavLink> 
                        </ListItem>: null
                      }
                      { getAccesos.Alm_Equipos ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Equipos'); }} >
                          <NavLink to ="/Almacen_Equipos" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <QueuePlayNextIcon/>
                              </Grid>
                              <Grid item xs={8}>                          
                                <ListItemText className={classes.listit} primary="EQUIPOS" />
                                </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Alm_Stock ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Stock'); }} >
                          <NavLink to ="/Almacen_Stock" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <AddShoppingCartIcon/>
                              </Grid>
                              <Grid item xs={8}>                           
                                <ListItemText className={classes.listit} primary="STOCK" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Alm_Tipos ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Tipos'); }} >
                          <NavLink to ="/Almacen_Tipos" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <BuildIcon/>
                                </Grid>
                              <Grid item xs={8}> 
                                <ListItemText className={classes.listit} primary="TIPOS" />
                                </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Alm_Marcas ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Marcas'); }} >
                          <NavLink to ="/Almacen_Marcas" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <MediumOutlinedIcon style={{fontSize:24}} />
                              </Grid>
                              <Grid item xs={8}>                       
                                <ListItemText className={classes.listit} primary="MARCAS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Alm_Tecnologia ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Almacen/Tecnologia'); }} >
                          <NavLink to ="/Almacen_Tecnologia" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <DeploymentUnitOutlinedIcon style={{fontSize:26}}/>
                              </Grid>
                              <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="TECNOLOGIAS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      </List>
                  </Collapse>
              </List>
              <Divider/>
            </React.Fragment>
          : null
        }
        {
          getSecciones['O.T.'] ?
            <React.Fragment>
              <List>
                <ListItem button onClick={ handleClickOtrabajo }>
                  <ListItemIcon className={classes.listot}><WorkOutlineIcon /></ListItemIcon>
                  <ListItemText className={classes.listot} primary='O.T.' />
                  { Otrabajo ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={Otrabajo} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    { getAccesos.OT_Crear ?
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/OT/Crear'); }} >
                        <NavLink to ="/OT_Crear" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <FileAddOutlinedIcon style={{fontSize:22}} />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="CREAR" />
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                    { getAccesos.OT_Listado ?
                      <ListItem button className={classes.nested} onClick={()=>{ setRuta('/OT/Listado'); }} >
                        <NavLink to ="/OT_Listado" activeClassName={classes.optionActive} className={classes.navlink}>
                          <Grid
                            alignItems='center' 
                            className={classes.containerOption}
                            container
                            justifyContent='space-between'
                          >
                            <Grid item >
                              <FileSearchOutlinedIcon style={{fontSize:22}} />
                            </Grid>
                            <Grid item xs={8}>
                              <ListItemText className={classes.listit} primary="LISTADO" />    
                            </Grid>
                            <Grid item>
                              <RightIcon className={classes.iconRight}/>  
                            </Grid>
                          </Grid>          
                        </NavLink>
                      </ListItem>  : null
                    }
                  </List>
                </Collapse>
              </List>
              <Divider />
            </React.Fragment>
          : null
        }
        {
          getSecciones.Configuracion ?
            <React.Fragment>
              <List>
                  <ListItem button onClick={ handleClickConf }>
                    <ListItemIcon className={classes.listot}><SettingsIcon /></ListItemIcon>
                    <ListItemText className={classes.listot} primary='CONFIGURACION' />
                    {listConf ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={listConf} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      { getAccesos.Conf_Backups ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Backups'); }} >
                          <NavLink to ="/Conf_Backups" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <RocketOutlinedIcon style={{fontSize:24}}/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="BACKUP" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_CambioIP ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/CambioIP'); }} >
                          <NavLink to ="/Conf_CambioIP" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SwapVerticalCircleIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="CAMBIO_IP" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Empresas ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Empresas'); }} >
                          <NavLink to ="/Conf_Empresas" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <ApartmentIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="EMPRESAS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Equipos ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Equipos'); }} >
                          <NavLink to ="/Conf_Equipos" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <QueuePlayNextIcon/>
                              </Grid>
                              <Grid item xs={8}>                        
                                <ListItemText className={classes.listit} primary="EQUIPOS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      } 
                      { getAccesos.Conf_Feriados ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Feriados'); }} >
                          <NavLink to ="/Conf_Feriados" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <EventAvailableIcon/>
                              </Grid>
                              <Grid item xs={8}>                        
                                <ListItemText className={classes.listit} primary="FERIADOS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      } 
                      { getAccesos.Conf_Modulos ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Modulos'); }} >
                          <NavLink to ="/Conf_Modulos" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <PhonelinkSetupIcon/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="MODULOS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Notificaciones ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Notificaciones'); }} >
                          <NavLink to ="/Conf_Notificaciones" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <NotificationOutlinedIcon style={{fontSize:20}}/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="NOTIFICACIONES" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Planes ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Planes'); }} >
                          <NavLink to ="/Conf_Planes" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SpeedIcon/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="PLANES" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Procesos ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Procesos'); }} >
                          <NavLink to ="/Conf_Procesos" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SettingsIcon/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="PROCESOS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Tareas ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Tareas'); }} >
                          <NavLink to ="/Conf_Tareas" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <AssignmentTurnedInIcon/>
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="TAREAS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Usuarios ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Usuarios'); }} >
                          <NavLink to ="/Conf_Usuarios" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SupervisedUserCircleIcon />
                              </Grid>
                              <Grid item xs={8}>                       
                                <ListItemText className={classes.listit} primary="USUARIOS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Whatsapps ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Whatsapps'); }} >
                          <NavLink to ="/Conf_Whatsapps" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <SmsIcon />
                              </Grid>
                              <Grid item xs={8}>                   
                                <ListItemText className={classes.listit} primary="WHATSAPPS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Wweb ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/wwwebJs'); }} >
                          <NavLink to ="/Conf_Wweb" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <WhatsAppIcon />
                              </Grid>
                              <Grid item xs={8}>                       
                                <ListItemText className={classes.listit} primary="WWWEBJS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                      { getAccesos.Conf_Zonas ?
                        <ListItem button className={classes.nested} onClick={()=>{ setRuta('/Conf/Zonas'); }} >
                          <NavLink to ="/Conf_Zonas" activeClassName={classes.optionActive} className={classes.navlink}>
                            <Grid
                              alignItems='center' 
                              className={classes.containerOption}
                              container
                              justifyContent='space-between'
                            >
                              <Grid item >
                                <NotListedLocationIcon />
                              </Grid>
                              <Grid item xs={8}>
                                <ListItemText className={classes.listit} primary="ZONAS" />
                              </Grid>
                              <Grid item>
                                <RightIcon className={classes.iconRight}/>  
                              </Grid>
                            </Grid>          
                          </NavLink>
                        </ListItem>  : null
                      }
                    </List>
                  </Collapse>
              </List>
            </React.Fragment>
          : null
        }
      </div>
    );

    const handleCloseUser = () => {setAnchorEl(null);};

    const handleMenuUser = (event) => {setAnchorEl(event.currentTarget);};
  
    const handleCloseSession = () =>{
      setAdmin(false);
      setShowAppbar(false);
      setAnchorEl(null);
      setOpen(false);
      setAuthTokens();
      setLoggedIn(false);
      setSecciones({});
      setAccesos({});
      setImagesAvatar([]);
      setAvatar('');
      setImgA(false);
      localStorage.removeItem("tokens_byYounet_");
    };

    const handleOpenAvatar = ()=>{
      setOpenAvatar(true);
    };

    const handleCloseAvatar = ()=>{
      setOpenAvatar(false);
    };

    const onChangeAvatar = (imageList, addUpdateIndex)=>{
      if(isImgA){
        if(imageList.length === 0){ 
          setOpenPhotoA(true);
        }else{
          setImgA(false);
          setChangeA(true);
          setImagesAvatar(imageList);
        }
      }else{   
        setChangeA(true);    
        setImagesAvatar(imageList);
      }
    };

    const handleDeleteAvatar = ()=>{
      setSavingAvatar(true);
      setAvatar('');
      fetch('/AvatarImg',{  
        method:'DELETE',
        body: JSON.stringify({Avatar:existingTokens.Avatar, UserName:existingTokens.UserName}),
        headers:{
            'Content-Type': 'application/json'}
      })
      .then(response => response.json())
      .then(result => {             
          if(result.message){
            const data = {...authTokens};
            data.Avatar = '';
            localStorage.setItem("tokens_byYounet_", JSON.stringify(data));
            setImgA(false);
            setSavingAvatar(false);
            setOpenPhotoA(false);
            setImagesAvatar([]);
            messageAntd.success(result.message);
            messageAntd.success(result.message);
          }else{
            console.error(result.status);
            messageAntd.error(result.status);
            messageAntd.error(result.status);
          }
      });
    };

    const handleChangeAvatar = ()=>{
      const nameAvatar = `${existingTokens.Empresa}_${existingTokens.UserName}.${imagesAvatar.length > 0 ? imagesAvatar[0].file.name.split('.').pop().toString() : 'jpg'}`;
      if(isChangeA){
        if(imagesAvatar.length > 0){
            setSavingAvatar(true);
            setAvatar(`avatar/${nameAvatar}`);
            const infoUser = {...authTokens};
            infoUser.Avatar = `avatar/${nameAvatar}`;
            localStorage.setItem("tokens_byYounet_", JSON.stringify(infoUser));
            const formD = new FormData();
            formD.append('imagen',imagesAvatar[0].file, nameAvatar);
            fetch('/AvatarImg',{method:'POST',body:formD})
            .then(response => response.json())
            .then(result => {             
                if(result.message){
                  messageAntd.success(result.message);
                  messageAntd.success(result.message);
                  setTimeout(()=>{
                    setSavingAvatar(false);
                  },1000)
                }else{
                  console.error(result.status);
                  messageAntd.error(result.status);
                  messageAntd.error(result.status);
                  setSavingAvatar(false);
                }
            });
        }
      }
    };

    const handleCancelarAvatar = ()=>{ setOpenPhotoA(false); };

    const handleCloseViewer = ()=>{ setOpenViewer(false); }

    return (
        <Router>
          <MuiThemeProvider theme={Traktecom}>
              <div className={clsx(classes.root, {[classes.root2]: !showAppbar,})} >
              <Snackbar
                open={snacks.status}
                onClose={()=>setSnacks({...snacks, status:false})}
                anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                autoHideDuration={3000}
                TransitionComponent={Slide}
                action={
                  <React.Fragment>
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={()=>setSnacks({...snacks, status:false})}
                    >
                      <CloseIcon />
                    </IconButton>
                  </React.Fragment>
                }
              >
                <Alert onClose={()=>setSnacks({...snacks, status:false})}  severity={snacks.severity}>
                  {snacks.message}
                </Alert>
              </Snackbar>
                <CssBaseline />
                {showAppbar && 
                    <AppBar position='fixed' className={classes.appBar} elevation={0}>
                      <Toolbar style={{display:'flex', justifyContent:'space-between'}} >
                          <IconButton  aria-label="open drawer" onClick={handleDrawerOpen} edge="start" className={classes.menuButton}>
                              <MenuIcon />
                          </IconButton>
                          <div>
                            {widthWin === 'xl' || widthWin === 'lg' ? <img src={LogoPng} alt='SYSINTERCOM'style={{width:105, height:40, marginRight:15}}/> : null}
                            <Chip label={getRuta} color='default' icon={<ExploreIcon/>}/>
                          </div>
                          <div style={{width:130,height:65, display:'flex', flexDirection:'row'}}>
                          <FormControl className={classes.formControl}>
                            <Select
                              value={ageWork}
                              onChange={HandleChangeAge}
                              displayEmpty
                              className={classes.selectEmpty}
                              inputProps={{ 'aria-label': 'Without label' }}
                              autoWidth
                            >
                              <MenuItem value="" disabled style={{color:'#fffff'}}>
                                Año
                              </MenuItem>
                              <MenuItem value={2021} style={{color:'#fffff'}}>2021</MenuItem>
                              <MenuItem value={2022} style={{color:'#fffff'}}>2022</MenuItem>
                              <MenuItem value={2023} style={{color:'#fffff'}}>2023</MenuItem>
                              <MenuItem value={2024} style={{color:'#fffff'}}>2024</MenuItem>
                              <MenuItem value={2025} style={{color:'#fffff'}}>2025</MenuItem>
                            </Select>
                          </FormControl>
                            {isLoggedIn && (
                              <div className={classes.divAv}>
                                <IconButton
                                  aria-label="account of current user"
                                  aria-controls="menu-appbar"
                                  aria-haspopup="true"
                                  onClick={handleMenuUser}
                                  color="secondary"
                                  style={{position:'relative', left:-8}}
                                >
                                  {
                                    isSavingAvatar
                                    ?<Avatar alt={authTokens.UserName} style={{backgroundColor:deepOrange.A400}}  src={getAvatar} key={Date.now()}/>
                                    :<Avatar alt={authTokens.UserName} style={{backgroundColor:deepOrange.A400}}  src={getAvatar} key={Date.now()}/>
                                  }
                                  
                                </IconButton>
                                <Menu
                                  id="menu-appbar"
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }}
                                  keepMounted
                                  transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }}
                                  open={openUser}
                                  onClose={handleCloseUser}
                                >
                                  <MenuItem>
                                    <Chip label={authTokens.NombresReducidos} color='primary' icon={<PersonIcon/>}/>
                                  </MenuItem>
                                  <MenuItem>
                                    <Divider style={{width:'100%'}}/>
                                  </MenuItem>
                                  <MenuItem onClick={handleOpenAvatar} ><CachedIcon style={{color:blue[700], position:'relative', left:-2}}/>&nbsp;&nbsp;&nbsp;&nbsp;Avatar</MenuItem>
                                  {
                                    isAdmin &&                               
                                    <MenuItem >
                                        <NavLink to="/Conf_Usuarios" className="link" ><AddIcon style={{color:green[500], position:'relative', top:6, left:-2}}/>Crear Usuario</NavLink>
                                    </MenuItem>
                                  }    
                                  <MenuItem onClick={handleCloseSession}><CloseIcon style={{color:red[700], position:'relative', left:-2}}/>Cerrar Sesion</MenuItem>              
                                </Menu>
                              </div>)
                            }
                          </div>
                          
                      </Toolbar>
                    </AppBar>
                }
                <Drawer anchor='left' open={open} onClose={()=>setOpen(false)} className={classes.drawer} classes={{paper: classes.drawerPaper}}>
                  <Scrollbars autoHide autoHideTimeout={1000} autoHideDuration={200}>
                    { drawer }
                  </Scrollbars>
                </Drawer>
                <ImgsViewer imgs={imagesAvatar} isOpen={viewerIsOpen} onClose={handleCloseViewer} />
                <Dialog
                  open={isOpenAvatar}
                  onClose={handleCloseAvatar}
                  fullWidth
                  maxWidth={'sm'}
                  style={{padding:0}}
                  disableEscapeKeyDown
                >
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseAvatar}>
                        AVATAR
                    </DialogTitle>
                    <DialogContent>
                      <Grid container justifyContent='center' alignItems='center'>
                        <Grid item sm={6} xs={12}>
                          <div className="App">
                              <ImageUploading
                                  multiple
                                  value={imagesAvatar}
                                  onChange={onChangeAvatar}
                                  maxNumber={1}
                                  dataURLKey="data_url"
                              >
                                  {({
                                  imageList,
                                  onImageUpload,
                                  onImageRemoveAll,
                                  onImageUpdate,
                                  onImageRemove,
                                  isDragging,
                                  dragProps,
                                  }) => (
                                  // write your building UI
                                  <Grid container justifyContent='center' spacing={2}>
                                      <Grid item xs={9}>
                                          <Button 
                                              variant="contained" 
                                              color="secondary"
                                              fullWidth
                                              size='large'
                                              disabled={isImgA}
                                              style={isDragging ? { color: 'red' } : undefined}
                                              onClick={onImageUpload}
                                              {...dragProps}
                                          >
                                              Click or Drop here
                                          </Button>
                                      </Grid>
                                      <Grid item xs={9}>
                                          {imageList.map((image, index) => (
                                              <Grid container alignItems='center' justifyContent='center' key={index} direction='column'>
                                                  <Grid item onClick={()=>{setOpenViewer(true);}}>
                                                      <img src={image['data_url']} alt="" width="100" key={Date.now()}/>
                                                  </Grid>
                                                  <Grid item xs={12}>
                                                      <Grid container justifyContent='center'>
                                                          <Grid item>
                                                              <IconButton
                                                                  onClick={() => onImageRemove(index)}
                                                                  size='small'
                                                                  color='secondary'
                                                                  style={{color:"red"}}
                                                              >
                                                                  <DeleteIcon/>
                                                              </IconButton>
                                                          </Grid>
                                                      </Grid>                                                             
                                                  </Grid>
                                              </Grid>
                                          ))}
                                      </Grid>
                                  </Grid>
                                  )}
                              </ImageUploading>
                          </div>
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions style={{display:'flex', justifyContent:'center'}}>
                        <Button onClick={handleChangeAvatar} color="primary" variant='contained' style={{color:'#fff'}} disabled={isSavingAvatar} startIcon={ isSavingAvatar ? <FacebookCircularProgress size={25} />: <SaveIcon/> }>
                            GUARDAR
                        </Button>
                        <Button onClick={()=>{ setOpenAvatar(false)}} color="default" variant='contained' style={{color:'#fff'}}>
                            CANCELAR
                        </Button>
                    </DialogActions>
                </Dialog> 
                <Dialog
                  open={openPhotoA}
                  onClose={handleCancelarAvatar}
                  fullWidth
                  maxWidth={'sm'}
                  style={{padding:0}}
                  disableEscapeKeyDown
                >
                    <DialogTitle id="customized-dialog-title" onClose={handleCancelarAvatar}>
                        SE ELIMINARA EL LOGO DE LA BASE DE DATOS
                    </DialogTitle>
                    <DialogActions style={{display:'flex', justifyContent:'center'}}>
                        <Button onClick={handleDeleteAvatar} color="primary" variant='contained' style={{color:'#fff'}}>
                            PROCEDER
                        </Button>
                        <Button onClick={handleCancelarAvatar} color="default" variant='contained' style={{color:'#fff'}}>
                            CANCELAR
                        </Button>
                    </DialogActions>
                </Dialog> 
                <main className={clsx(classes.content, {[classes.contentLogin]:isInLogin})}>            
                  <Switch> 
                    <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens, ageWork, setAgeWork, isInLogin, setIsInLogin, setShowAppbar, setOpen, setRuta, open, isLoggedIn, setLoggedIn, setAdmin, isAdmin, setAvatar, setUpdateAvatar, setSavingAvatar, setImgA, setImagesAvatar }}>
                      <Route path="/Login" component={isLoggedIn ? Inicio : Login}/> 
                      <Route path="/ChangeWifi" component={Younet_ChangeWifi} exact/> 
                      <PrivateRoute path="/" component={Inicio} exact/>
                      <PrivateRoute path="/Almacen_Matriz" component={isLoggedIn ? getAccesos.Alm_Matriz ? Alm_Matriz : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Proveedores" component={isLoggedIn ? getAccesos.Alm_Proveedores ? Alm_Proveedores : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Equipos" component={isLoggedIn ? getAccesos.Alm_Equipos ? Alm_Equipos : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Stock" component={isLoggedIn ? getAccesos.Alm_Stock ? Alm_Stock : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Tipos" component={isLoggedIn ? getAccesos.Alm_Tipos ? Alm_Tipos : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Marcas" component={isLoggedIn ? getAccesos.Alm_Marcas ? Alm_Marcas : NoAcceso : Login}/>
                      <PrivateRoute path="/Almacen_Tecnologia" component={isLoggedIn ? getAccesos.Alm_Tecnologia ? Alm_Tecnologia : NoAcceso : Login}/>
                      <PrivateRoute path="/Mikrotik_List" component={isLoggedIn ? getAccesos.Mikrotik_List ? Mikrotik_List : NoAcceso : Login}/>
                      <PrivateRoute path="/Clientes_Add" component={isLoggedIn ? getAccesos.Younet_ClientAdd ? Younet_ClientAdd : NoAcceso : Login}/>
                      <PrivateRoute path="/Clientes_Soporte" component={isLoggedIn ? getAccesos.Younet_ClientShow ? Younet_ClientShow : NoAcceso : Login}/>
                      <PrivateRoute path="/Clientes_Listado" component={isLoggedIn ? getAccesos.Younet_ClientList ? Younet_ClientList : NoAcceso : Login}/>
                      <PrivateRoute path="/Clientes_ListadoD" component={isLoggedIn ? getAccesos.Younet_ClientListDet ? Younet_ClientListDet : NoAcceso : Login}/>
                      <PrivateRoute path="/Clientes_CambiarZona" component={isLoggedIn ? getAccesos.Younet_ChangeZone ? Younet_ChangeZone : NoAcceso : Login}/>                 
                      <PrivateRoute path="/Clientes_CambioPlanes" component={isLoggedIn ? getAccesos.Clientes_CambioPlanes ? Clientes_CambioPlanes : NoAcceso : Login}/>                 
                      <PrivateRoute path="/Clientes/MigracionMk" component={isLoggedIn ? getAccesos.MigracionMk ? MigracionMk : NoAcceso : Login}/>                 
                      <PrivateRoute path="/Adicionales_Crear" component={isLoggedIn ? getAccesos.Adicionales_Crear ? Adicionales_Crear : NoAcceso : Login}/>
                      <PrivateRoute path="/Adicionales_Listado" component={isLoggedIn ? getAccesos.Adicionales_Listado ? Adicionales_Listado : NoAcceso : Login}/>
                      <PrivateRoute path="/Descuentos_Crear" component={isLoggedIn ? getAccesos.Descuentos_Crear ? Descuentos_Crear : NoAcceso : Login}/>
                      <PrivateRoute path="/Descuentos_Listado" component={isLoggedIn ? getAccesos.Descuentos_Listado ? Descuentos_Listado : NoAcceso : Login}/>
                      <PrivateRoute path="/Servicios_Bancos" component={isLoggedIn ? getAccesos.Servicios_Bancos ? Servicios_Bancos : NoAcceso : Login}/>
                      <PrivateRoute path="/Servicios_Instalaciones" component={isLoggedIn ? getAccesos.Servicios_Instalaciones ? Servicios_Instalaciones : NoAcceso : Login}/>
                      <PrivateRoute path="/Servicios_Pagos" component={isLoggedIn ? getAccesos.Servicios_Pagos ? Servicios_Pagos : NoAcceso : Login}/>
                      <PrivateRoute path="/Servicios_Promesas" component={isLoggedIn ? getAccesos.Servicios_Promesas ? Servicios_Promesas : NoAcceso : Login}/>
                      <PrivateRoute path="/Reporteria_Arcotel" component={isLoggedIn ? getAccesos.ReportesArcotel ? ReportesArcotel : NoAcceso : Login}/>
                      <PrivateRoute path="/Reporteria_Facturas" component={isLoggedIn ? getAccesos.ReportesFacturas ? ReportesFacturas : NoAcceso : Login}/>
                      <PrivateRoute path="/Reporteria_Pagos" component={isLoggedIn ? getAccesos.Younet_ReporteriaPagos ? Younet_ReporteriaPagos : NoAcceso : Login}/>              
                      <PrivateRoute path="/Reporteria_Recibos" component={isLoggedIn ? getAccesos.ReportesRecibos ? ReportesRecibos : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Backups" component={isLoggedIn ? getAccesos.Conf_Backups ? Conf_Backups : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_CambioIP" component={isLoggedIn ? getAccesos.Conf_CambioIP ? Conf_CambioIP : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Empresas" component={isLoggedIn ? getAccesos.Conf_Empresas ? Conf_Empresas : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Equipos" component={isLoggedIn ? getAccesos.Conf_Equipos ? Conf_Equipos : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Feriados" component={isLoggedIn ? getAccesos.Conf_Feriados ? Conf_Feriados : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Modulos" component={isLoggedIn ? getAccesos.Conf_Modulos ? Conf_Modulos : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Notificaciones" component={isLoggedIn ? getAccesos.Conf_Notificaciones ? Conf_Notificaciones : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Planes" component={isLoggedIn ? getAccesos.Conf_Planes ? Conf_Planes : NoAcceso : Login}/>                      
                      <PrivateRoute path="/Conf_Procesos" component={isLoggedIn ? getAccesos.Conf_Procesos ? Conf_Procesos : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Tareas" component={isLoggedIn ? getAccesos.Conf_Tareas ? Conf_Tareas : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Tecnicos" component={isLoggedIn ? getAccesos.Conf_Tecnicos ? Conf_Tecnicos : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Usuarios" component={isLoggedIn ? getAccesos.Conf_Usuarios ?  Conf_Usuarios : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Whatsapps" component={isLoggedIn ? getAccesos.Conf_Whatsapps ?  Conf_Whatsapps : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Wweb" component={isLoggedIn ? getAccesos.Conf_Wweb ?  Conf_Wweb : NoAcceso : Login}/>
                      <PrivateRoute path="/Conf_Zonas" component={isLoggedIn ? getAccesos.Conf_Zonas ? Conf_Zonas : NoAcceso : Login}/>
                      <PrivateRoute path="/OT_Crear" component={isLoggedIn ? getAccesos.OT_Crear ? OT_Crear : NoAcceso : Login}/>
                      <PrivateRoute path="/OT_Listado" component={isLoggedIn ? getAccesos.OT_Listado ? OT_Listado : NoAcceso : Login}/>
                    </AuthContext.Provider> 
                  </Switch>
                </main>
              </div>
          </MuiThemeProvider>
        </Router>
    );

}

export default withWidth()(App);